module.exports = __webpack_public_path__ + "static/img/gc_tb2_1.18527ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/hardWare/gc/gc_tb2_1.png
// module id = DCpB
// module chunks = 0